export const inboxChangedEventName = "workhub:inbox-updated";

type InboxEventTarget = Pick<
  EventTarget,
  "addEventListener" | "dispatchEvent" | "removeEventListener"
>;

function defaultInboxEventTarget(): InboxEventTarget {
  if (typeof window === "undefined") {
    throw new Error("inbox_event_target_unavailable");
  }
  return window;
}

export function notifyInboxChanged(target: InboxEventTarget = defaultInboxEventTarget()): void {
  target.dispatchEvent(new Event(inboxChangedEventName));
}

export function subscribeToInboxChanges(
  listener: () => void,
  target: InboxEventTarget = defaultInboxEventTarget(),
): () => void {
  const eventListener = () => listener();
  target.addEventListener(inboxChangedEventName, eventListener);
  return () => target.removeEventListener(inboxChangedEventName, eventListener);
}
